export enum ActivityVideoConferenceToolEnum {
  JITSI = 'e3ee7403-c619-4d0a-b239-f142d08a5c3c',
  ZOOM = 'cbb9c71c-7d72-4f00-9e8c-e064b9315cf9',
  MICROSOFTTEAMS = 'bb8bd744-8aee-46a2-acc7-6b5c18c25146',
  OTHER = '0b4ab405-ea05-402b-b3f0-706f455d05c8'
}
